<template>
  <div class="w-title_auxiliaryDecoration">
    <div>
      <span class="w-text_auxiliaryDecoration">{{ xText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    xText: {
      required: true,
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {},
  components: {}
}
</script>

<style scoped lang="scss">
.w-title_auxiliaryDecoration {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  z-index: 1;
  & > div {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100%;
    position: relative;
  }
  & > div::after {
    content: '';
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.85);
    z-index: 1;
  }
  span {
    font-family:'Source Han Sans-Bold'; 
    display: inline-block;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
  }
}
.w-title_auxiliaryDecoration::after {
  content: '';
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  border-bottom: 1px solid #dce0ec;
}
</style>
